/**
 * Expenditure capture (FSD Part 3, TRS-S08). The wiring packet spreads
 * `TREASURY_WALLET_EXPENDITURE_ROUTES` into the router beside `TREASURY_ROUTES`.
 *
 * Gated on `treasury.wallet.read`, the permission the transaction list route
 * declares; the screen shows record/submit only with `treasury.wallet.capture`
 * and reverse only with `treasury.wallet.approve`, and the list itself is
 * row-scoped server-side (a custodian sees their own floats).
 */

import type { RouteRecordRaw } from 'vue-router'

import { TREASURY_PERMISSIONS } from '@/modules/treasury/permissions'

export const TREASURY_WALLET_EXPENDITURE_PATH = '/treasury/wallet-expenditure'

export const TREASURY_WALLET_EXPENDITURE_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_WALLET_EXPENDITURE_PATH,
    name: 'treasury-wallet-expenditure',
    component: () => import('@/modules/treasury/wallet-expenditure/WalletExpenditureView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.walletExpenditure',
      permission: TREASURY_PERMISSIONS.walletRead,
    },
  },
]
